export default __webpack_public_path__ + "ecf53bd.png";